<div class="mt-6 w-full flex flex-col gap-5">
  <p-toast></p-toast>
  <p-confirmdialog />

  <p-card>
    <ng-template #title>
      <h1>
        {{
          isEditMode()
            ? ('controlPoints.qualifications.edit' | translate)
            : ('controlPoints.qualifications.add' | translate)
        }}
      </h1>
    </ng-template>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="flex flex-col gap-4">
      <div class="flex flex-col">
        <label for="qual-name" class="text-sm mb-1">
          {{ 'controlPoints.qualifications.fields.name' | translate }}
        </label>
        <input
          id="qual-name"
          pInputText
          formControlName="name"
          [maxlength]="255"
        />
        @if (form.get('name')?.touched && form.get('name')?.invalid) {
          <small class="text-red-500 mt-1">
            {{ 'validation.required' | translate }}
          </small>
        }
      </div>

      <div class="flex flex-col">
        <label for="qual-description" class="text-sm mb-1">
          {{ 'controlPoints.qualifications.fields.description' | translate }}
        </label>
        <textarea
          id="qual-description"
          pTextarea
          formControlName="description"
          rows="3"
          class="w-full"
        ></textarea>
      </div>

      <div class="flex flex-col">
        <label for="qual-trainers" class="text-sm mb-1">
          {{ 'controlPoints.qualifications.fields.trainers' | translate }}
        </label>
        <p-multiselect
          inputId="qual-trainers"
          formControlName="user_ids"
          [options]="service.trainers()"
          optionLabel="name"
          optionValue="id"
          [filter]="true"
          filterBy="name"
          display="chip"
          appendTo="body"
          styleClass="w-full"
          [placeholder]="
            'controlPoints.qualifications.fields.trainersPlaceholder' | translate
          "
        />
        <small class="text-color-secondary mt-1">
          {{ 'controlPoints.qualifications.fields.trainersHint' | translate }}
        </small>
      </div>

      <div class="flex justify-between items-center pt-2">
        <p-button
          type="button"
          severity="secondary"
          [label]="'label.cancel' | translate"
          (onClick)="onCancel()"
        />
        <div class="flex gap-2">
          @if (isEditMode() && model()) {
            <p-button
              type="button"
              severity="danger"
              icon="fa fa-trash"
              [label]="'label.delete' | translate"
              (onClick)="onDelete($event)"
            />
          }
          <p-button
            type="submit"
            [label]="'label.save' | translate"
            [loading]="submitting()"
          />
        </div>
      </div>
    </form>
  </p-card>
</div>
